module.exports = __webpack_public_path__ + "static/media/AWSEdstart.d0d968d5.jpg";